module.exports = __webpack_public_path__ + "img/box copy.ce868f6d.svg";